import { render } from "./AdminEOC.vue?vue&type=template&id=23f1d1db"
import script from "./AdminEOC.vue?vue&type=script&lang=js"
export * from "./AdminEOC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__